import bizNodeModel from '../../bizNodeModel.mjs'
import SrcType from '../components/SrcType.mjs'
import getRuleType from './RuleType.jsx'

export default bizNodeModel({
    srcType: {
        name: () => '来源类型',

        readableValue: (map, node) => {
            const {srcType} = node.data

            if (srcType) {
                const match = SrcType.find(e => srcType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    subUrl: {
        name: () => '子类URL',
    },

    feignMethod: {
        name: () => 'Feign接口方法签名',
    },

    resume: {
        name: () => '简述',
    },

    ruleKey: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '处理能力关键字' : '程序能力关键字'
        }
    },

    ruleStar: {
        name: () => '星标',
    },

    ruleTitle: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '处理能力标题' : '程序能力标题'
        },

        required: () => true,
    },

    ruleType: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '处理能力类型' : '程序能力类型'
        },

        readableValue: (map, node) => {
            const RuleType = getRuleType(map)
            const {ruleType} = node.data

            if (ruleType) {
                const match = RuleType.find(e => ruleType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    iterativeFlag: {
        name: () => '是否迭代',
    },

    ruleUserCode: {
        name: (map, node) => {
            const {subTypeCode} = map.data
            return 'BODA1' === subTypeCode ? '处理能力代码' : '程序能力代码'
        },
    },

    url: {
        name: () => 'URL',
    },
})
